import { render } from "./deliver.vue?vue&type=template&id=58c2f6f8&scoped=true"
import script from "./deliver.vue?vue&type=script&lang=js"
export * from "./deliver.vue?vue&type=script&lang=js"

import "./deliver.vue?vue&type=style&index=0&id=58c2f6f8&lang=scss&scoped=true"
import "./deliver.vue?vue&type=style&index=1&id=58c2f6f8&lang=scss"

import exportComponent from "/data/jenkins/workspace/talk-community-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58c2f6f8"]])

export default __exports__